import React from 'react'
import { useTranslation } from 'react-i18next'

import TrustpilotProductMiniWidget from '../../../shared/components/atoms/TrustpilotProductMiniWidget'
import { MIX_BUNDLE, PANTS_BUNDLE } from '../../utils/bab/bab.utils'

import './bundle-selector.styles.scss'

const BundleSelector = ({
  bundle,
  currentBundle,
  clickHandler,
  ...otherProps
}) => {
  const { t } = useTranslation('updatedBAB')
  const { id, imageSources, translationKeys } = bundle

  return (
    <li
      className='bundle-selector'
      data-grey={
        (id === PANTS_BUNDLE.id && currentBundle === MIX_BUNDLE.id) ||
        (id === MIX_BUNDLE.id && currentBundle === PANTS_BUNDLE.id)
          ? ''
          : null
      }
      data-active={currentBundle === id ? '' : null}
      data-bundle-type={id}
    >
      <img
        className='bundle-selector-image'
        src={`${t(imageSources.bundle)}?width=140`}
        alt={t(translationKeys.imageAlt)}
        width='140'
        height='140'
        loading='lazy'
      />
      <p className='bundle-selector-title'>{`${t(
        translationKeys.bundleName
      )} >`}</p>
      <div className='bundle-reviews-container'>
        <TrustpilotProductMiniWidget
          sku={
            id === MIX_BUNDLE.id
              ? 'JOONECHARGE.BUNDLE.CC.C.V1'
              : id === PANTS_BUNDLE.id
                ? 'JOONECHARGE.BUNDLE.CC.V1'
                : 'JOONECHARGE.BUNDLE.C.V1'
          }
        />
      </div>
      <p
        className='bundle-selector-text'
        data-bundle={id}
        onClick={clickHandler}
      >
        {t('bundle.readMore')}
      </p>
    </li>
  )
}

export default BundleSelector
